import React, { useCallback, useRef, useState } from 'react'
import {
    createColumnHelper,
    getCoreRowModel,
    useReactTable,
    getSortedRowModel
} from '@tanstack/react-table'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { Button, Dropdown, Form, InputGroup, Modal } from 'react-bootstrap'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { Controller, set, useForm } from 'react-hook-form'
import ReactTable from '../../components/ReactTable'
import Pagination from '../../components/Pagination'
import requestApi from '../../utils/request'
import { formatDateToMonthShortwithFormate, getFormData } from '../../functions/common'
import Swal from 'sweetalert2'
import { ReactComponent as Eyes } from '../../assets/images/teyes.svg'
import { ReactComponent as Edit } from '../../assets/images/tedit.svg'
import { ReactComponent as Delete } from '../../assets/images/tdelete.svg'
import { ReactComponent as DeleteImg } from '../../assets/images/redbin.svg'
import { ReactComponent as SearchIcon } from '../../assets/images/greysearch.svg'
import { ReactComponent as FilterIcon } from '../../assets/images/filter.svg'
import { employerview, jobopeningview } from '../../Routes/routingConsts'
import DropDownControl from '../../components/DropDownControl/DropDownControl'
import SpinnerLoader from '../../components/SpinnerLoader'
import { ReactComponent as SelectImg } from '../../assets/images/selectimg.svg'
import { Spinner } from 'react-bootstrap'
import { useEffect } from 'react'
import {
    deleteActionIcon,
    viewIcon,
    editactionIcon
} from '../../functions/actionIcons'
import FlottedButton from '../../components/FlottingButton'
import ButtonWithLoader from '../../components/ButtonWithLoader/ButtonWithLoader'
import InputControl from '../../components/InputControl/InputControl'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import ckeditor, { CKEditor } from '@ckeditor/ckeditor5-react'
import defaultThumb from '../../assets/images/blog_custom_icon.png'

const ClientPartner = () => {
    const navigate = useNavigate()
    const [ckeditordata, setckeditordata] = useState('')
    const [toggle, setToggle] = useState(null)
    const queryClient = useQueryClient()
    const [DataLimit, setDataLimit] = useState(10)
    const [editValueID, setEditValueID] = useState('')
    const [currentPage, setCurrentPage] = useState(1)
    const EditDataRef = useRef(null)
    const [userFilterText, setuserFilterText] = useState('')
    const handleChange2 = (e) => {
        setCurrentPage(1)
        const getData = setTimeout(() => {
            setuserFilterText(e.target.value)
        }, 1000)
        clearInterval()
    }

    const handleChange = (eventkey) => {
        setDataLimit(eventkey)
    }

    function editjobopening(categoryItem) {
        setShowAdd(true)
        for (const key in categoryItem) {
            setValue(key,categoryItem[key])
        }
        setImageUrl(categoryItem.image)
        setEditClientPatnerId(categoryItem.clientPatnerId)
    }

    /////status filter////
    const [statusControl, setStatusControl] = useState('')
    const handleChangeStatus = (eventKey) => {
        setCurrentPage(1)
        setStatusControl(eventKey)
    }

    const clientpartnervalidation = yup.object({
        name: yup.string().max(45,"Maximum charactor is 45").nullable().trim().required('Please enter Client Partner Name.'),
    })

    const {
        control,
        register,
        watch,
        clearErrors,
        handleSubmit,
        reset,
        setError,
        setValue,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(clientpartnervalidation),
        shouldUnregister: true,
      
    })

    const [sorting, setSorting] = useState([])

    function UserList({ queryKey }) {
        return requestApi
            .post(
                `/clientPatner/list`,
                {
                    search: queryKey[3],
                    limit: queryKey[2],
                    page: queryKey[1],
                    sortKey: queryKey[4]?.id ?? '',
                    sortBy: queryKey[4] ? (queryKey[4]?.desc ? -1 : 1) : '',
                    status: statusControl
                },
                { headers: true }
            )
            .then((res) => {
                return res.data
            })
    }
    const { data, isLoading } = useQuery({
        queryKey: [
            'jobOpeninglist',
            currentPage,
            DataLimit,
            userFilterText,
            sorting[0],
            statusControl
        ],
        queryFn: UserList
        // select: () => {
        //     return {
        //         data: null
        //     }
        // }
    })

    let totalJobOpening = data?.meta?.totalCount

    const handleChangePage = useCallback(
        (currentPage) => {
            setCurrentPage(currentPage)
        },
        [currentPage]
    )

    const columnHelper = createColumnHelper()
    const columns = [
        columnHelper.display({
            id: 'actions',
            header: 'Action',
            cell: (row) => {
                return (
                    <>
                        <div className="">
                            <FlottedButton
                                clickFn={() => {
                                    setToggle((pre) =>
                                        pre === row.row.original?.clientPatnerId
                                            ? null
                                            : row.row.original?.clientPatnerId
                                    )
                                }}
                                isTrue={
                                    row.row.original?.clientPatnerId === toggle
                                }
                            >
                                {row.row.original.status === 3
                                    ? ''
                                    : ''}
                                <li
                                    className=" i1 icon"
                                    onClick={() => {
                                        editjobopening(row.row.original)
                                    }}
                                >
                                    {editactionIcon}
                                </li>
                                {row.row.original.status === 3 ? (
                                    ''
                                ) : (
                                    <li
                                        className=" i1 icon"
                                        onClick={() =>
                                            hanleDeleteModal(
                                                row.row.original?.clientPatnerId
                                            )
                                        }
                                    >
                                        {deleteActionIcon}
                                    </li>
                                )}
                            </FlottedButton>
                        </div>
                    </>
                )
            }
        }),

        columnHelper.accessor((row) => row.image, {
            id: 'image',
            header: 'Photo',
            enableSorting:false,
            cell: (row) => {
                return <img src={row.row.original?.image} />
            }
        }),

        columnHelper.accessor((row) => row.name, {
            id: 'name',
            header: 'Name',
            cell: (row) => {
                return <p>{row.row.original?.name}</p>
            }
        }),
        columnHelper.accessor((row) => row.createdAt, {
            id: 'createdAt',
            header: 'Created At',
            cell: (row) => {
                return (
                    <p>
                        {row.row.original?.createdAt &&
                            formatDateToMonthShortwithFormate(
                                row.row.original?.createdAt
                            )}
                    </p>
                )
            }
        }),
    ]
    useEffect(() => {
        if (currentPage && data?.data?.length == 0) {
            setCurrentPage(1)
        } else {
        }
    }, [currentPage, data?.data])

    // End useEffect ////

    const tableInstance = useReactTable({
        data: data?.data,
        columns: columns,
        state: {
            sorting
        },
        onSortingChange: setSorting,
        getSortedRowModel: getSortedRowModel(),
        getCoreRowModel: getCoreRowModel()
    })

    const uploadImage = useRef(null)
    const [imageUrl, setImageUrl] = useState(null)
    const [imageErr,setimageErr] = useState('')
    const [submitValidation, setSubmitValidation] = useState(false);

    console.log('imageUrl',imageUrl)
    console.log('imageErr',imageErr)

    const handleFileUpload = (e) => {  
        if (
            e.target.files[0].type === 'image/jpg' ||
            e.target.files[0].type === 'image/jpeg' ||
            e.target.files[0].type === 'image/png'
        ) {
            setValue('image', e.target.files[0])
            setImageUrl(URL.createObjectURL(e.target.files[0]))   
            setimageErr('')
        } else {
            setimageErr('Please select .jpeg, .jpg or .png file formate.')
        }
    }

    //Add or Edit User
    const [showAdd, setShowAdd] = useState(false)
    const [addCategoryValue, setAddCategoryValue] = useState('')
    const [editClientPatnerId, setEditClientPatnerId] = useState('');


    async function newAddClientPatner(payload) {
        if (editClientPatnerId) {

            return await requestApi
                .post(
                    `clientPatner/add-edit`,
                    payload
                )
                .then((res) => {
                    return res.data
                })
        } else {

            return await requestApi
                .post(
                    `clientPatner/add-edit`,
                    payload
                )
                .then((res) => {
                    return res.data
                })
        }
    }
    const mutationAddEdit = useMutation(newAddClientPatner, {
        onSuccess: (data) => {
           
            queryClient.invalidateQueries('jobOpeninglist')
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                allowOutsideClick: false,
                text: data?.meta?.message
            })
            reset()
            setImageUrl('')
            setShowAdd(false)
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                allowOutsideClick: false,
                text: error?.message
            })
        }
    })

    const handleAddEditCompliance = () => {
        mutationAddEdit.mutate(addCategoryValue)
        setShowAdd(false)
    }

    // Delete Client Partner
    const [showDelete, setShowDelete] = useState(false)
    const [deletedId, setDeletedId] = useState(null)

    async function deletecategoryId(clientPatnerId) {
        return await requestApi.post(`/clientPatner/delete`, {
            clientPatnerId
        })
    }
    const mutationDelete = useMutation(deletecategoryId, {
        onSuccess: ({ data }) => {
            queryClient.invalidateQueries('jobOpeninglist')
            setShowDelete(false)
            EditDataRef.current = null
        },
        onError: (error) => {
            EditDataRef.current = null
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                text: error?.message
            })
        }
    })

    const hanleAddModal = () => {
        setShowAdd(true)
    }
    const hanleDeleteModal = (clientPatnerId) => {
        setShowDelete(true)
        setDeletedId(clientPatnerId)
    }
    const handleDeleteUser = (clientPatnerId) => {
        mutationDelete.mutate(clientPatnerId)
        setShowDelete(false)
    }

    const handleClientPartner=(data)=>{
    
        const payload = {
            name: data.name,
            image: data.image
         }

        try{ 
            if(data.image !== undefined)
            {
                if (editClientPatnerId) {
                   payload.clientPatnerId=editClientPatnerId
                }
                
                const formdata = getFormData(payload)
                mutationAddEdit.mutate(formdata)
                setEditClientPatnerId('')
            }

        }catch(e){
               console.log(e.message)
        }
    }

    return (
        <>
            <div className="sidebar-content common-page">
                <div className="contentwhole-box details-box client-partner-box">
                    <div className="filter-titlebox">
                        <div className="title-text">
                            <h3>Client Partner</h3>
                        </div>
                        <div className="filterbox">
                            <div className="searcskills myaccount-page">
                                <div>
                                    <div className="searchstatus-box">
                                        <InputGroup className="mb-3 input-wrapper">
                                            <InputGroup.Text id="basic-addon1">
                                                <SearchIcon />
                                            </InputGroup.Text>
                                            <Form.Control
                                                placeholder="Search"
                                                type="search"
                                                aria-label="Username"
                                                aria-describedby="basic-addon1"
                                                className="icontrol"
                                                {...register(
                                                    'jobOpeningSearch',
                                                    {
                                                        onChange: (e) => {
                                                            handleChange2(e)
                                                        }
                                                    }
                                                )}
                                            />
                                        </InputGroup>
                                        <Button
                                            style={{padding: '0 10px', marginLeft: '20px', width: '100%'}}
                                            className="common-btn save-btn"
                                            onClick={() => hanleAddModal()}
                                        >
                                        + Add Client Partner
                                        </Button>       
                                    </div>
                                </div>
                            </div>      
                        </div>
                    </div>

                    {isLoading ? (
                        <div className="spinner-wrapper">
                            <Spinner
                                animation="border"
                                role="status"
                                className="tdata"
                            >
                                <span className="visually-hidden">
                                    Loading...
                                </span>
                            </Spinner>
                        </div>
                    ) : (
                        <>
                            {' '}
                            {data?.data?.length > 0 ? (
                                <>
                                    <ReactTable tableInstance={tableInstance} />
                                    <div className="paginationbox">
                                        <div className="showingpages">
                                            <span>
                                                Showing{' '}
                                                {(currentPage - 1) * DataLimit +
                                                    1}{' '}
                                                to{' '}
                                                {Math.min(
                                                    currentPage * DataLimit,
                                                    totalJobOpening
                                                )}{' '}
                                                of {totalJobOpening} Client Partners
                                            </span>
                                        </div>
                                        {totalJobOpening > 10 && <div className="itemsperpage">
                                            <span>Items per page:</span>
                                            <Dropdown
                                                flip="no"
                                                onSelect={handleChange}
                                            >
                                                <Dropdown.Toggle
                                                    variant="success"
                                                    id="dropdown-basic"
                                                >
                                                    {DataLimit}
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu>
                                                    <Dropdown.Item eventKey="10">
                                                        10
                                                    </Dropdown.Item>
                                                    <Dropdown.Item eventKey="20">
                                                        20
                                                    </Dropdown.Item>
                                                    <Dropdown.Item eventKey="30">
                                                        30
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>}
                                        {totalJobOpening > 10 && (
                                            <div className="pagination">
                                                <Pagination
                                                    total={Math.ceil(
                                                        totalJobOpening /
                                                            DataLimit
                                                    )}
                                                    current={currentPage}
                                                    onChangePage={
                                                        handleChangePage
                                                    }
                                                />
                                            </div>
                                        )}
                                    </div>
                                </>
                            ) : (
                                <div className="noresult">
                                    <p>No Result Found</p>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
            <Modal size="lg"
                style={{backdropFilter: 'blur(2px)'}}
                className="modalbox showAdd"
                show={showAdd}
                onHide={() => {
                    setEditClientPatnerId('')
                    setAddCategoryValue('')
                    setShowAdd(false)
                    reset()
                    setValue("clientPatnerId",null)
                    setSubmitValidation(false)
                    setImageUrl(null)
                }}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <h3>{editClientPatnerId === '' ? 'Add Client Partner' : 'Edit Client Partner'}</h3>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <Form onSubmit={handleSubmit(handleClientPartner)}>

                        <div className="col-12 mb-3 mt-5">
                                <div className="profile-image">
                                   {imageUrl ? <img src={imageUrl} alt="" /> : <img src={defaultThumb} alt="" style={{ borderRadius: "0" }} /> } 
                                    <div
                                        className="selectimg"
                                        onClick={() => uploadImage.current.click()}
                                    >
                                        <input
                                            type="file"
                                            ref={(event) => {
                                                register('image')
                                                uploadImage.current = event
                                            }}
                                            accept=".jpg,.png,.jpeg"
                                            style={{ display: 'none' }}
                                            onChange={handleFileUpload}
                                        />
                                        <SelectImg />
                                    </div>
                                </div>
                                {submitValidation === true && imageUrl === null && <span className="error-message">{"Please select .jpeg, .jpg or .png file formate."}</span>}
                            </div>

                            <InputControl
                                label="Name"
                                name="name"
                                register={register}
                                autoFocus="true"
                                error={
                                    errors?.name?.message
                                }
                            />
                        
                            <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                <Button
                                type='submit'
                                    style={{ padding: '0 10px' }}
                                    className="common-btn save-btn"
                                    onClick={() =>  {setSubmitValidation(true)}}
                                    // onClick={() => handleAddEditCopliance()}
                                    // onClick={() => console.log("hsfgsjhdkj")}
                                >
                                    Submit
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                className="modalbox deletemodal"
                show={showDelete}
                onHide={() => setShowDelete(false)}
                backdrop="static"
                keyboard={false}
                style={{backdropFilter: 'blur(2px)'}}
            >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <Form className="formbox">
                        <div className="delete-box">
                            <div className="deleteimg">
                                <DeleteImg />
                            </div>
                            <div className="content">
                                <h4>
                                    Are you sure you want to delete this <br />
                                    Client Partner?
                                </h4>
                            </div>
                            <div className="delete-action">
                                <button
                                    className="common-btn yes"
                                    type="button"
                                    onClick={() => handleDeleteUser(deletedId)}
                                >
                                    Yes
                                </button>
                                <button
                                    className="common-btn no"
                                    type="button"
                                    onClick={() => setShowDelete(false)}
                                >
                                    No
                                </button>
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ClientPartner
